import { Modal, Button, Stack } from '@mantine/core';
import { useEffect, useRef } from 'react';
import { useFilterFormContext } from '@/pages/Statistics/StatisticsPage';
import type { Filter } from '@/schemas/API/POST/statistics/request';
import { formatDateToYYYYMMDD } from '@/utils/Date';
import FormAgeRangeInput from './FilterInputs/FormAgeRangeInput';
import FormSelectSex from './FilterInputs/FormSelectSex';
import FormWorkedHoursSlider from './FilterInputs/FormWorkedHoursSlider';
import FormPriceRangeInput from './FilterInputs/FormPriceRangeInput';
import { FormStateSelect } from './FilterInputs/FormStateSelect';
import FormLocalityMultiSelect from './FilterInputs/FormLocationMultiSelect';

interface FilterModalProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (filters: Filter) => void;
  selectedCategory: string;
  monthly: boolean;
  date: Date | null;
  localities: Locality[]
}

export interface Locality {
  id: string;
  name: string;
}

const FilterModal: React.FC<FilterModalProps> = ({
  opened,
  onClose,
  onSubmit,
  selectedCategory,
  monthly,
  date,
  localities,
}) => {
  const form = useFilterFormContext();
  const prevCategoryRef = useRef(selectedCategory);

  useEffect(() => {
    if (prevCategoryRef.current !== selectedCategory) {
      form.reset();
      if (date) {
        form.setFieldValue('date', formatDateToYYYYMMDD(date));
      }
      prevCategoryRef.current = selectedCategory;
    }
  }, [selectedCategory, date, form]);


  useEffect(() => {
    if (date) form.setFieldValue('date', formatDateToYYYYMMDD(date));
  }, [monthly, date]);

  const renderEmployeeFields = () => (
    <>
      <FormAgeRangeInput />

      <FormLocalityMultiSelect localities={localities}/>

      <FormSelectSex />

      <FormWorkedHoursSlider monthly={monthly} />
    </>
  );

  const renderClientFields = () => (
    <>
      <FormAgeRangeInput />

      <FormSelectSex />

      <FormPriceRangeInput />
    </>
  );

  const renderApplicantFields = () => (
    <>
      <FormAgeRangeInput />

      <FormStateSelect />

      <FormSelectSex />
    </>
  );

  const getCategoryFields = () => {
    switch (selectedCategory) {
      case 'employees':
        return renderEmployeeFields();
      case 'clients':
        return renderClientFields();
      case 'applicants':
        return renderApplicantFields();
      default:
        return renderEmployeeFields();
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Nastavení filtru" size="xl">
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack>
          {getCategoryFields()}
          <Button type="submit">Použít filtr</Button>
        </Stack>
      </form>
    </Modal>
  );
};

export default FilterModal;
